import { c as _c } from "react/compiler-runtime";
import './child-bio-details.scss';
import { useRouter, useSearchParams } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import { HtmlBlock } from '@sola/ark-core/atoms/html/html.tsx';
import { TabGroup } from '@sola/ark-core/molecules/tab-group/tab-group.tsx';
import { useCart } from '@sola/cart-sdk/store.tsx';
import { ChildAvailabilityItem, ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { countryToIso } from '@sola/schema/dotcom/shared/geo.ts';
import { useChildSponsorship } from '../../hooks/useChildSponsorship.ts';
import { key } from '../../organisms-cms/child-bio/utils/bioKeys.tsx';
import { getNote } from '../../organisms-cms/child-bio/utils/childNote.tsx';
import { getAge } from '../../utils/child-bio.ts';
import { ChildBioDetailsHeading } from './child-bio-details-heading.tsx';
import { ChildBioDetailsOverview } from './child-bio-details-overview.tsx';
import { ChildBioInfo } from './child-bio-info.tsx';
import { SubmitButton } from './child-bio-sponsorship-submit-button.tsx';
import { ChildBioSummary } from './child-bio-summary.tsx';
export const ChildBioDetails = t0 => {
  const $ = _c(76);
  const {
    seoLevel: t1,
    details
  } = t0;
  const seoLevel = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["bio", "geo"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  useRouter();
  useSearchParams();
  useCart("actions");
  const {
    ageInYearsAndMonths,
    country,
    correspondenceLanguage,
    globalId,
    localId,
    name,
    hangul
  } = details;
  let t3;
  if ($[1] !== ageInYearsAndMonths) {
    t3 = getAge(ageInYearsAndMonths);
    $[1] = ageInYearsAndMonths;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const age = t3;
  const isToddler = age === "1" || age === "2";
  let communityDescription;
  let countryKey;
  let t4;
  let translatedCountry;
  if ($[3] !== country || $[4] !== localId || $[5] !== t) {
    const countryIso = countryToIso(country, localId);
    countryKey = String("geo:countries.").concat(countryIso).concat(".nameS");
    translatedCountry = t(countryKey as unknown as TemplateStringsArray);
    communityDescription = t("bio:community", {
      context: countryIso
    });
    t4 = t("bio:description", {
      context: countryIso
    });
    $[3] = country;
    $[4] = localId;
    $[5] = t;
    $[6] = communityDescription;
    $[7] = countryKey;
    $[8] = t4;
    $[9] = translatedCountry;
  } else {
    communityDescription = $[6];
    countryKey = $[7];
    t4 = $[8];
    translatedCountry = $[9];
  }
  const countryDescription = t4;
  let t5;
  if ($[10] !== correspondenceLanguage || $[11] !== t) {
    const languageKey = key("bio:language", correspondenceLanguage);
    t5 = t(languageKey as unknown as TemplateStringsArray);
    $[10] = correspondenceLanguage;
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const translatedLanguage = t5;
  let t6;
  if ($[13] !== details) {
    t6 = getNote(details);
    $[13] = details;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const note = t6;
  const {
    isSubmitting,
    bioErrors,
    handleSponsorshipSubmit
  } = useChildSponsorship(globalId);
  const t7 = seoLevel + 1;
  let t8;
  if ($[15] !== t) {
    t8 = t("bio:overview");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== details || $[18] !== hangul || $[19] !== isToddler || $[20] !== name || $[21] !== seoLevel || $[22] !== t) {
    t9 = isToddler ? <HtmlBlock htmlString={t("bio:babyParagraphs", {
      childName: name.preferred,
      koreanName: hangul.preferred || name.preferred
    })} /> : <ChildBioDetailsOverview seoLevel={seoLevel} details={details} />;
    $[17] = details;
    $[18] = hangul;
    $[19] = isToddler;
    $[20] = name;
    $[21] = seoLevel;
    $[22] = t;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = {
      seoLevel: t7,
      title: t8,
      tabKey: "overview",
      body: t9
    };
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  const overviewTab = t10;
  const t11 = seoLevel + 1;
  let t12;
  if ($[28] !== t) {
    t12 = t("bio:community");
    $[28] = t;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const t13 = communityDescription as string;
  let t14;
  if ($[30] !== t13) {
    t14 = <HtmlBlock htmlString={t13} />;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t11 || $[33] !== t12 || $[34] !== t14) {
    t15 = {
      seoLevel: t11,
      title: t12,
      tabKey: "community",
      body: t14
    };
    $[32] = t11;
    $[33] = t12;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const communityTab = t15;
  const t16 = seoLevel + 1;
  let t17;
  if ($[36] !== t) {
    t17 = t("bio:country");
    $[36] = t;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const t18 = countryDescription as string;
  let t19;
  if ($[38] !== t18) {
    t19 = <HtmlBlock htmlString={t18} />;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t16 || $[41] !== t17 || $[42] !== t19) {
    t20 = {
      seoLevel: t16,
      title: t17,
      tabKey: "country",
      body: t19
    };
    $[40] = t16;
    $[41] = t17;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  const countryTab = t20;
  let t21;
  if ($[44] !== hangul || $[45] !== name || $[46] !== seoLevel) {
    t21 = <ChildBioDetailsHeading seoLevel={seoLevel} hangul={hangul} name={name} />;
    $[44] = hangul;
    $[45] = name;
    $[46] = seoLevel;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== details || $[49] !== translatedCountry || $[50] !== translatedLanguage) {
    t22 = <ChildBioSummary details={details} translatedCountry={translatedCountry} translatedLanguage={translatedLanguage} />;
    $[48] = details;
    $[49] = translatedCountry;
    $[50] = translatedLanguage;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== countryKey || $[53] !== details || $[54] !== note) {
    t23 = <ChildBioInfo details={details} countryKey={countryKey} note={note} />;
    $[52] = countryKey;
    $[53] = details;
    $[54] = note;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== bioErrors || $[57] !== details || $[58] !== handleSponsorshipSubmit || $[59] !== isSubmitting) {
    t24 = <SubmitButton bioErrors={bioErrors} className="mt-comfy-xl" details={details} isSubmitting={isSubmitting} handleSponsorshipSubmit={handleSponsorshipSubmit} />;
    $[56] = bioErrors;
    $[57] = details;
    $[58] = handleSponsorshipSubmit;
    $[59] = isSubmitting;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== t21 || $[62] !== t22 || $[63] !== t23 || $[64] !== t24) {
    t25 = <div className="ChildBioDetails__intro">{t21}{t22}{t23}{t24}</div>;
    $[61] = t21;
    $[62] = t22;
    $[63] = t23;
    $[64] = t24;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== communityTab || $[67] !== countryTab || $[68] !== overviewTab) {
    t26 = [overviewTab, communityTab, countryTab];
    $[66] = communityTab;
    $[67] = countryTab;
    $[68] = overviewTab;
    $[69] = t26;
  } else {
    t26 = $[69];
  }
  let t27;
  if ($[70] !== overviewTab.tabKey || $[71] !== t26) {
    t27 = <div className="ChildBioDetails__content"><TabGroup activeValue={overviewTab.tabKey} items={t26} /></div>;
    $[70] = overviewTab.tabKey;
    $[71] = t26;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== t25 || $[74] !== t27) {
    t28 = <div className="ChildBioDetails body-md xl:pr-comfy-xl grid gap-roomy-sm">{t25}{t27}</div>;
    $[73] = t25;
    $[74] = t27;
    $[75] = t28;
  } else {
    t28 = $[75];
  }
  return t28;
};